module.exports = __webpack_public_path__ + "img/update.ee1b72f6.svg";